export default Object.freeze({
  SINGLE_LIST: 'single_list',
  CATEGORY_GROUP: 'category_group',
  CATEGORIES_ONLY: 'categories_only',
});
